export const AdminViewTabs = {
  USER_SUMMARY: "USER_SUMMARY",
  BROCHURES: "BROCHURES",
  CANNED_MESSAGES: "CANNED_MESSAGES",
};

export const SessionItems = {
  ADMIN_ACTIVE_TAB: "ADMIN_ACTIVE_TAB",
};
